import { DotLoader } from "@/components/ui/Loader/DotLoader";
import { cn } from "@/utils/cn";
import { ReactNode } from "react";

type LineItemProps =
  | {
      keyName: string;
      value?: string;
      isLoading?: boolean;
      children?: never;
      className?: string;
      keyClassName?: string;
      valueClassName?: string;
    }
  | {
      children: ReactNode;
      keyName?: never;
      value?: never;
      isLoading?: never;
      className?: string;
      keyClassName?: never;
      valueClassName?: never;
    };

const LineItem = ({
  keyName,
  value,
  isLoading,
  children,
  className,
  keyClassName,
  valueClassName,
}: LineItemProps) => {
  if (children) {
    return <>{children}</>;
  }

  return (
    <div
      id="Cart-Line-Item"
      className={cn(
        "flex items-center justify-between font-archivo font-light",
        className,
      )}
    >
      <div
        className={cn(
          "text-base leading-[22.4px] tracking-[0.16px] text-type-1 capitalize",
          keyClassName,
        )}
      >
        {keyName}
      </div>
      <div
        className={cn(
          "text-base leading-[22.4px] tracking-[0.16px] text-type-1",
          valueClassName,
        )}
      >
        {isLoading ? <DotLoader size={16} /> : value}
      </div>
    </div>
  );
};

export default LineItem;
